import React, { useState, useEffect } from 'react'
import { Row, Col, Button, Form, Tooltip, OverlayTrigger } from "react-bootstrap";
import Toast from '../../../../../../../GlobalComponents/Toast';
import styles from './ProfileMicrosoftResellerPrerequisite.module.scss';
import { CSP_VERIFY_MPNID, CSP_SAVE_MPNID, GET_CSP_MPNID_DATA, UPDATE_CSP_MPNID } from '../../../../../../../Utils/GlobalConstants';
import { api } from '../../../../../../../Utils/API';
import loadingGif from "../../../../../../../Assets/Images/Animations/loading-management-console.gif"
import EmptyDataTableFilterSearch from '../../../../../../../Assets/Images/Illustrations/EmptyDataTableFilterSearch.svg'
import { TOAST_ERROR_ICON_COLOR, TOAST_SUCCESS_ICON_COLOR } from '../../../../../../../Utils/ColorsConfiguration';
import { GenericServerError } from '../../../../../../../Utils/StaticMessages/GenericErrorMessages';
import { MPNIdErrorToast, MPNIdSavedSuccessToast, MPNIdUpdationSuccessToast, ServerErrorPLAVerification } from '../../../../../../../Utils/StaticMessages/ToastMessages';

const ProfileMicrosoftResellerPrerequisite = ({ Logout }) => {
  const [mpnId, setMpnId] = useState("");
  // const [verifyMessage, setVerifyMessage] = useState("");                       // verified success or error message after verification of MPN ID
  const [isMpnVerified, setIsMpnVerified] = useState(false);                     // To check mpn id/Partner Location Account (ID)(new ui label change) is verified or not
  const [confirmLoadingFlag, setConfirmLoadingFlag] = useState(false);          // Processing after calling api
  const [isAlreadyConfigured, setIsAlreadyConfigured] = useState(false);        // To check whether mpn id/Partner Location Account (ID)(new ui label change) is already configured or not
  const [alreadyConfiguredMpnId, setAlreadyConfiguredMpnId] = useState("");     // if mpn is already there
  // const [isEditAllowed, setIsEditAllowed] = useState(false);                    // edit mpn id/Partner Location Account (ID)(new ui label change) when clicked
  // const [isMPNIdExpired, setIsMPNIdExpired] = useState(false);                  // To check whether mpn id/Partner Location Account (ID)(new ui label change) is expired or not 
  const [previousMPNid, setPreviousMPNid] = useState("");                       // for saving mpn id/Partner Location Account (ID)(new ui label change) which is already configured
  const [mpnData, setMpnData] = useState("");                                   // data storing from mpn id/Partner Location Account (ID)(new ui label change) get api
  const [isVerificationHold, setIsVerificationHold] = useState(false);          // intermediate state for buttons control and check
  const [serverError, setServerError] = useState(false);                        // server error check state in table during api call to load data

  //plan id message and mpn id message
  const [mpnVerifyMessage, setMpnVerifyMessage] = useState("");                       
  const [plaVerifyMessage, setPlaVerifyMessage] = useState("");                       
  const [mpnHelpMessage, setMpnHelpMessage] = useState("");                      
  const [plaHelpMessage, setPlaHelpMessage] = useState("");                      
  const [isValidMpaStatus, setIsValidMpaStatus] = useState("");                      
  const [isValidPlaId, setIsValidPlaId] = useState("");                      
  const [partnerName, setPartnerName] = useState(""); 
  const [mpnMessage, setMpnMessage] = useState("");                       
  const [mpnInfoMessage, setMpnInfoMessage] = useState("");                     

  // Use State for Toasts
  const [toastSuccess, setToastSuccess] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastError, setToastError] = useState(false);                                // toast message displaying error message 

  // Header Authorization for API
  const config = {
    headers: {
      "Authorization": `${localStorage.getItem("token_type")} ${localStorage.getItem("access_token")}`,
    },
  };

  // Function to get details whether mpn id/Partner Location Account (ID)(new ui label change) is already configured or not
  async function GetMPNData() {
    await api.get(GET_CSP_MPNID_DATA, config)
      .then(resp => {
        setMpnData(resp.data);
        setIsAlreadyConfigured(resp.data.isAlreadyConfigured);
        setPreviousMPNid(resp.data.plaId);
        setAlreadyConfiguredMpnId(resp.data.plaId);
        setPartnerName(resp.data.partnerName);

        if(resp.data.isAlreadyConfigured){
        setMpnVerifyMessage(resp.data.mpaMessage);
        setPlaVerifyMessage(resp.data.plaMessage);
        setMpnHelpMessage(resp.data.mpaHelpMessage);
        setPlaHelpMessage(resp.data.plaHelpMessage)
        setIsValidMpaStatus(resp.data.isValidMpaStatus);
        setIsValidPlaId(resp.data.isValidPlaId);}

        setServerError(false);
      })
      .catch(error => {
        if (error?.status == 401 || error?.response?.status == 401) {
          Logout();
        }
        else {
          setServerError(true);
        }
      });
  };

  //post api for mpn id/Partner Location Account (ID)(new ui label change) verification
  async function MPNidVerification(mpnId) {
    setConfirmLoadingFlag(true);
    const configFile = {
      headers: {
        "Authorization": `${localStorage.getItem("token_type")} ${localStorage.getItem("access_token")}`,
        "Content-Type": "application/json",
      },
    };
    await api.post(`${CSP_VERIFY_MPNID}?plaId=${mpnId}`, null, configFile)
      .then(resp => {
        if (resp.status = 200) {
          { resp.data.isValidPlaId && resp.data.isValidMpaStatus  ? setIsMpnVerified(true) : setIsMpnVerified(false) }
          // setVerifyMessage(resp.data.message);

          setMpnVerifyMessage(resp.data.mpaMessage);
          setPlaVerifyMessage(resp.data.plaMessage);
          setMpnHelpMessage(resp.data.mpaHelpMessage);
          setPlaHelpMessage(resp.data.plaHelpMessage)
          setIsValidMpaStatus(resp.data.isValidMpaStatus);
          setIsValidPlaId(resp.data.isValidPlaId);
          setPartnerName(resp.data.partnerName);
          setMpnMessage(resp.data.mpnMessage === null ? "" : resp.data.mpnMessage);                   
          setMpnInfoMessage(resp.data.mpnHelpMessage === null ? "" : resp.data.mpnHelpMessage);  
          setConfirmLoadingFlag(false);
          setIsVerificationHold(false);
        }
      })
      .catch(error => {
        setConfirmLoadingFlag(false);
        if (error?.status == 401 || error?.response?.status == 401) {
          Logout();
        }
        else{
        setIsVerificationHold(false);
        setToastMessage(ServerErrorPLAVerification);
          setToastError(true);
          setTimeout(() => {
            setToastError(false);
          }, 5000);
        }
      })
  };

  //post api for saving mpn id/Partner Location Account (ID)(new ui label change)
  async function MPNidSave(mpnId) {
    setConfirmLoadingFlag(true);
    const configFile = {
      headers: {
        "Authorization": `${localStorage.getItem("token_type")} ${localStorage.getItem("access_token")}`,
        "Content-Type": "application/json",
      },
    };
    await api.post(`${CSP_SAVE_MPNID}?mpnId=${mpnId}&partnerName=${partnerName}`, null, configFile)
      .then(resp => {
        if (resp.status = 200) {
          setConfirmLoadingFlag(false);
          // setIsEditAllowed(false);
          setMpnData(null);
          // setVerifyMessage(""); 
          setIsMpnVerified(false);
          setPreviousMPNid("");
          GetMPNData();
          setToastMessage(MPNIdSavedSuccessToast);
          setToastSuccess(true);
          setTimeout(() => {
            setToastSuccess(false);
          }, 5000);
        }
      })
      .catch(error => {
        setConfirmLoadingFlag(false);
        if (error?.status == 401 || error?.response?.status == 401) {
          Logout();
        }
        else {
          setToastMessage(MPNIdErrorToast);
          setToastError(true);
          setTimeout(() => {
            setToastError(false);
          }, 5000);
        }
      })
  };

  //put api for Updating mpn id/Partner Location Account (ID)(new ui label change)
  async function MPNidUpdate(mpnId) {
    setConfirmLoadingFlag(true);
    const configFile = {
      headers: {
        "Authorization": `${localStorage.getItem("token_type")} ${localStorage.getItem("access_token")}`,
        "Content-Type": "application/json",
      },
    };
    await api.put(`${UPDATE_CSP_MPNID}?mpnId=${mpnId}&partnerName=${partnerName}`, null, configFile)
      .then(resp => {
        if (resp.status = 200) {
          GetMPNData();
          setConfirmLoadingFlag(false);
          setPreviousMPNid("");
          // setIsEditAllowed(false);
          // setVerifyMessage(""); 
          setIsMpnVerified(false);
          setToastMessage(MPNIdUpdationSuccessToast);
          setToastSuccess(true);
          setTimeout(() => {
            setToastSuccess(false);
          }, 5000);
        }
      })
      .catch(error => {
        setConfirmLoadingFlag(false);
        if (error?.status == 401 || error?.response?.status == 401) {
          Logout();
        }
        else if (error?.status == 500 || error?.response?.status == 500){
        setToastMessage(ServerErrorPLAVerification);
        setToastError(true);
          setTimeout(() => {
            setToastError(false);
          }, 5000);
        }
      })
  };

  //Scroll to top on opening of page
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  // Defining UseEffect to call get mpn id/Partner Location Account (ID)(new ui label change) 
  useEffect(() => {
    GetMPNData();
  }, []);

  return (
    <>
      <div className="main-content">
        <Toast toastSetUseState={setToastSuccess} toastCheckUseState={toastSuccess} toastType="success" toastIconColor={TOAST_SUCCESS_ICON_COLOR} toastMessage={toastMessage} />
        <Toast toastSetUseState={setToastError} toastCheckUseState={toastError} toastType="danger" toastIconColor={TOAST_ERROR_ICON_COLOR} toastMessage={toastMessage} />


        {serverError &&
          <div className={styles["no-data-cloud-summary"]}>
            <img src={EmptyDataTableFilterSearch} className="empty-cloud-creditNote-table-svg" />
            <h2 className="mt-4 mb-3">{GenericServerError}</h2>
          </div>
        }

        {/* if mpn id is not there */}
        {!isAlreadyConfigured && !serverError &&
          <>
            <div className={`details-box mt-5 card-remove-border-prerequisite`} eventKey="0">
              {!mpnData &&
                <div className={styles["no-data-cloud-summary"]}>
                  <div className="text-center"><img className="management-console-loading-icon" src={loadingGif} /><p className="text-medium text-strong management-console-loading-text">Loading...</p></div>
                </div>
              }
              {mpnData && <>
                <label className={`pt-5 pb-4 ${styles['accordion-content']}`}>
                  <span className={`text-large text-strong`}>Partner Location Account (PLA) ID</span>
                </label>
                <div className='pt-0'>
                  <div className={`${styles['accordion-content']}`}>

                    <>
                      <Row>
                        <Col lg={8} md={12}>
                          <Form.Group className="mb-3" >
                            <Form.Label>Partner Name - {partnerName ? partnerName : "NA"}</Form.Label>
                            <Row>
                              <Col md={6} >
                                <Form.Control
                                  type="number"
                                  value={mpnId}
                                  placeholder="Enter Partner Location Account (PLA) ID"
                                  onKeyDown={(e) => {
                                  if (["e", "E", "+", "-"].includes(e.key)) {
                                  e.preventDefault();
                                  }
                                  }}
                                  onChange={(e) => {
                                    setIsMpnVerified(false);
                                    setMpnVerifyMessage("");
                                    setPlaVerifyMessage("");
                                    setMpnHelpMessage("");
                                    setPlaHelpMessage("");
                                    setPartnerName("");
                                    setMpnMessage("");
                                    setMpnInfoMessage("");
                                    if (e.target.value === '' || /^[0-9]+$/.test(e.target.value) && e.target.value.length > 0) {
                                      setMpnId(e.target.value);
                                    }
                                  }}
                                />
                                  <>
                                {/* pla status */}

                                {isValidPlaId === true && plaVerifyMessage != "" && <span className='d-flex items-align-center mt-5'>
                                  <span className="status-success mr-1">&nbsp;</span>
                                  <span className="green text-medium">
                                    {plaVerifyMessage}
                                  </span> </span>}

                                {/* if MPN ID/Partner Location Account (ID)(new ui label change) verification is invalid  */}
                                {mpnMessage=== "" && isValidPlaId === false && plaVerifyMessage != "" &&
                                  <Row>
                                    <Col md={10}>
                                      <span className='d-flex items-align-center mt-5'>
                                        <span className="status-error mr-1">&nbsp;</span>
                                        <span className="red text-medium">
                                          {plaVerifyMessage + ". ("} <a href='https://learn.microsoft.com/en-us/partner-center/developer/validate-reseller-partner-of-record#common-error-codes' target="_blank">Click here </a> for more details{")"}
                                        </span>
                                      </span>
                                    </Col>
                                    <Col md={2} className='text-right'>
                                      <OverlayTrigger
                                        placement="right"
                                        overlay={<Tooltip className='tooltip-upgrade-destination'>
                                          {plaHelpMessage}
                                        </Tooltip>}
                                      >
                                        <span className="infoIcon-vendor-requirement mt-3"></span>
                                      </OverlayTrigger>
                                    </Col>
                                  </Row>}
                              </>

                              <>
                                {/* mpn status */}
                                {isValidMpaStatus === true &&  mpnVerifyMessage != "" && <span className='d-flex items-align-center mt-3'>
                                  <span className="status-success mr-1">&nbsp;</span>
                                  <span className="green text-medium">
                                    {mpnVerifyMessage}
                                  </span> </span>}

                                {/* if MPN ID/Partner Location Account (ID)(new ui label change) verification is invalid  */}
                                {mpnMessage=== "" && isValidMpaStatus === false && mpnVerifyMessage != "" &&
                                  <Row>
                                    <Col md={10}>
                                      <span className='d-flex items-align-center mt-3'>
                                        <span className="status-error mr-1">&nbsp;</span>
                                        <span className="red text-medium">
                                          {mpnVerifyMessage}
                                        </span>
                                      </span>
                                    </Col>
                                    <Col md={2} className='text-right'>
                                      <OverlayTrigger
                                        placement="right"
                                        overlay={<Tooltip className='tooltip-upgrade-destination'>
                                          {plaHelpMessage}
                                        </Tooltip>}
                                      >
                                        <span className="infoIcon-vendor-requirement mb-1 mt-2"></span>
                                      </OverlayTrigger>
                                    </Col>
                                  </Row>}
                                  {mpnMessage!== "" &&
                                    <Row>
                                      <Col md={10}>
                                        <span className='d-flex items-align-center mt-5'>
                                          <span className="status-error mr-1">&nbsp;</span>
                                          <span className="red text-medium">
                                            {mpnMessage + ". ("} <a href='https://learn.microsoft.com/en-us/partner-center/developer/validate-reseller-partner-of-record#common-error-codes' target="_blank">Click here </a> for more details{")"}
                                          </span>
                                        </span>
                                      </Col>
                                      <Col md={2} className='text-right'>
                                        <OverlayTrigger
                                          placement="right"
                                          overlay={<Tooltip className='tooltip-upgrade-destination'>
                                            {mpnInfoMessage}
                                          </Tooltip>}
                                        >
                                          <span className="infoIcon-vendor-requirement mt-3"></span>
                                        </OverlayTrigger>
                                      </Col>
                                    </Row>}
                                  </>
                              {isValidMpaStatus === null &&
                                <p className='empty-paragraph'></p>
                              }
                              {isValidPlaId === null &&
                                <p className='empty-paragraph'></p>
                              }
                              </Col>
                              <Col md={6}>
                                {mpnId.length > 0 ?
                                  (!confirmLoadingFlag && <Button
                                    className="btn btn-lg btn-border-light px-4 pl-11 pr-11"
                                    variant="light"
                                    onClick={() => { MPNidVerification(mpnId); setIsVerificationHold(true); }}
                                  >
                                    Verify
                                  </Button>) : (!confirmLoadingFlag && <Button
                                    className="btn btn-lg btn-border-light px-4 pl-11 pr-11"
                                    variant='light'
                                    disabled
                                  >
                                    Verify
                                  </Button>)}
                                {confirmLoadingFlag && 
                                  <Button
                                    disabled
                                    className="btn btn-lg btn-border-light px-4 pl-11 pr-11"
                                    variant="light"
                                  >
                                    Processing . . .
                                  </Button>
                                }

                              </Col>
                            </Row>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        <Col className="text-right">
                          <div className="button-wrapper mb-5 mr-2">
                            {!confirmLoadingFlag && <>
                              {mpnId.length > 0 &&
                                <Button
                                  className="btn btn-lg btn-border-light mx-2"
                                  variant="light"
                                  onClick={() => { 
                                    setMpnId(""); setIsMpnVerified(false);
                                    GetMPNData(); setMpnVerifyMessage(""); setPlaVerifyMessage("");setMpnMessage("");setMpnInfoMessage("");
                                  }}
                                >
                                  Clear
                                </Button>}
                              {mpnId.length === 0 && <Button
                                className="btn btn-lg mx-2"
                                variant="light"
                                disabled
                              >
                                Clear
                              </Button>}
                              {
                                !isMpnVerified &&
                                <>
                                  <Button
                                    className="btn btn-lg ml-2 px-4"
                                    variant="light"
                                    disabled
                                  >
                                    Save
                                  </Button>
                                </>
                              }

                              {
                                isMpnVerified &&
                                <Button
                                  className="btn btn-lg ml-2 px-4"
                                  onClick={() => {
                                    MPNidSave(mpnId);
                                  }}
                                >
                                  Save
                                </Button>
                              }
                            </>}

                            {confirmLoadingFlag && !isVerificationHold &&
                              <><Button
                                className="btn btn-lg mx-2"
                                variant="light"
                                disabled
                              >
                                Clear
                              </Button>

                                <Button
                                  disabled
                                  className="ml-2 px-4 btn-border-light w-md-auto col-xs-12"
                                  variant="light"
                                >
                                  Processing . . .
                                </Button>
                              </>
                            }
                            {confirmLoadingFlag && isVerificationHold &&
                              <><Button
                                className="btn btn-lg mx-2"
                                variant="light"
                                disabled
                              >
                                Clear
                              </Button>
                                <Button
                                  disabled
                                  className="ml-2 px-4 btn-border-light w-md-auto col-xs-12"
                                  variant="light"
                                >
                                  Save
                                </Button></>
                            }
                          </div>
                        </Col>
                      </Row>
                    </>
                  </div>
                </div>
              </>}
            </div>
          </>
        }
        {/* if mpn id/Partner Location Account (ID)(new ui label change) is already there */}
        {isAlreadyConfigured && mpnData && !serverError &&
          <>
            <div className={`pb-6 details-box mt-5 card-remove-border-prerequisite`} eventKey="0">
              <label className={`pt-5 pb-4 ${styles['accordion-content']}`}>
                <span className={`text-large text-strong`}>Partner Location Account (PLA) ID</span>
              </label>
              <div className='pt-0'>
                <div className={`${styles['accordion-content']}`}>
                  <Row>
                    <Col lg={8} md={12}>
                      <Form.Group className="mb-3" >
                        <Form.Label className="pb-1">Partner Name - {partnerName ? partnerName : "NA"}</Form.Label>
                        <Row>
                          <Col md={6}>
                            {/* {!isEditAllowed &&
                              <div className={`${isMPNIdExpired ? "red" : ""}`}>
                                {previousMPNid === "" ? "Loading ..." : previousMPNid}
                              </div>} */}
                            {
                            // isEditAllowed &&
                            <Form.Control
                              type="text"
                              value={alreadyConfiguredMpnId}
                              placeholder="Enter Partner Location Account (PLA) ID"
                              onKeyDown={(e) => {
                                if (["e", "E", "+", "-"].includes(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              onChange={(e) => {
                                setIsMpnVerified(null);
                                if (e.target.value === '' || /^[0-9]+$/.test(e.target.value) && e.target.value.length > 0) {
                                  setAlreadyConfiguredMpnId(e.target.value);
                                  setMpnVerifyMessage("");
                                  setPartnerName("");
                                  setPlaVerifyMessage("");
                                  setMpnHelpMessage("");
                                  setPlaHelpMessage("");
                                  setMpnMessage("");
                                  setMpnInfoMessage("");
                                }
                              }}
                            />
                            }

                            {/* {
                              isMPNIdExpired && 
                              // !isEditAllowed &&
                              <span className='d-flex items-align-center mt-2'>
                                <span className="status-error mr-1">&nbsp;</span>
                                <span className="red text-small">
                                  Partner Location Account (ID) is expired , please update the Partner Location Account (ID)
                                </span>
                              </span>} */}

                              {/* PLA ID Status */}
                            { 
                            // isEditAllowed && 
                            // !isMPNIdExpired && 
                            <>
                              {/* if MPN ID/Partner Location Account (ID)(new ui label change) verification is valid */}
                              {isValidPlaId === true && plaVerifyMessage != "" && <span className='d-flex items-align-center mt-5'>
                                <span className="status-success mr-1">&nbsp;</span>
                                <span className="green text-medium">
                                  {plaVerifyMessage}
                                </span> </span>}

                              {/* if MPN ID/Partner Location Account (ID)(new ui label change) verification is invalid  */}
                              {mpnMessage=== "" && isValidPlaId === false && plaVerifyMessage != "" &&
                              <Row>
                                <Col md={10}>
                                <span className='d-flex items-align-center mt-5'>
                                  <span className="status-error mr-1">&nbsp;</span>
                                  <span className="red text-medium justify-content-between items-align-center">
                                    {plaVerifyMessage + ". ("} <a href='https://learn.microsoft.com/en-us/partner-center/developer/validate-reseller-partner-of-record#common-error-codes' target="_blank">Click here </a> for more details{")"}
                                  </span>
                                 </span>
                                 </Col>
                                 <Col md={2} className='text-right'>
                                 <OverlayTrigger
                                    placement="right"
                                    overlay={<Tooltip className='tooltip-upgrade-destination'>
                                      {plaHelpMessage}
                                    </Tooltip>}
                                  >
                                    <span className="infoIcon-vendor-requirement mt-3"></span>
                                  </OverlayTrigger>
                                  </Col>
                                  </Row>
                                 }
                            </>
                            }

                                 {/* MPN ID status */}
                             { 
                            //  isEditAllowed && !isMPNIdExpired && 
                             <>
                              {/* if MPN ID/Partner Location Account (ID)(new ui label change) verification is valid */}
                              {isValidMpaStatus === true && mpnVerifyMessage != "" && <span className='d-flex items-align-center mt-3'>
                                <span className="status-success mr-1">&nbsp;</span>
                                <span className="green text-medium">
                                  {mpnVerifyMessage}
                                </span> </span>}

                              {/* if MPN ID/Partner Location Account (ID)(new ui label change) verification is invalid  */}
                              {mpnMessage=== "" && isValidMpaStatus === false && mpnVerifyMessage != "" &&
                              <Row>
                                <Col md={10}>
                                <span className='d-flex items-align-center mt-3'>
                                  <span className="status-error mr-1">&nbsp;</span>
                                  <span className="red text-medium">
                                    {mpnVerifyMessage}
                                  </span>
                                  </span>
                                  </Col>
                                 <Col md={2} className='text-right'>
                                 <OverlayTrigger
                                    placement="right"
                                    overlay={<Tooltip className='tooltip-upgrade-destination'>
                                      {mpnHelpMessage}
                                    </Tooltip>}
                                  >
                                    <span className="infoIcon-vendor-requirement mb-1 mt-2"></span>
                                  </OverlayTrigger>
                                  </Col>
                                </Row>}
                                {mpnMessage!== "" &&
                                  <Row>
                                    <Col md={10}>
                                      <span className='d-flex items-align-center mt-5'>
                                        <span className="status-error mr-1">&nbsp;</span>
                                        <span className="red text-medium">
                                          {mpnMessage + ". ("} <a href='https://learn.microsoft.com/en-us/partner-center/developer/validate-reseller-partner-of-record#common-error-codes' target="_blank">Click here </a> for more details{")"}
                                        </span>
                                      </span>
                                    </Col>
                                    <Col md={2} className='text-right'>
                                      <OverlayTrigger
                                        placement="right"
                                        overlay={<Tooltip className='tooltip-upgrade-destination'>
                                          {mpnInfoMessage}
                                        </Tooltip>}
                                      >
                                        <span className="infoIcon-vendor-requirement mt-3"></span>
                                      </OverlayTrigger>
                                    </Col>
                                  </Row>}
                            </>
                            }
                            {isValidMpaStatus === null &&
                              <p className='empty-paragraph'></p>
                            }
                             {isValidPlaId === null &&
                              <p className='empty-paragraph'></p>
                            }
                          </Col>
                          <Col md={6}>
                            {/* {!isEditAllowed &&
                              <Button
                                className="btn btn-lg btn-border-light px-4 pl-11 pr-11"
                                variant="light"
                                onClick={() => {
                                  setIsEditAllowed(true);
                                }}
                              >
                                Edit PLA ID</Button>} */}
                            {!confirmLoadingFlag && 
                            // isEditAllowed && 
                            alreadyConfiguredMpnId != previousMPNid && alreadyConfiguredMpnId.length != 0 && alreadyConfiguredMpnId.length > 0 &&
                              <Button
                                className="btn btn-lg btn-border-light px-4 pl-11 pr-11"
                                variant="light"
                                onClick={() => { MPNidVerification(alreadyConfiguredMpnId); setIsVerificationHold(true) }}
                              >
                                Verify</Button>}
                            {confirmLoadingFlag && 
                            // isEditAllowed &&
                              <Button
                                disabled
                                className="btn btn-lg btn-border-light px-4 pl-11 pr-11"
                                variant="light"
                              >
                                Processing . . .
                              </Button>
                            }
                            {
                            // isEditAllowed &&
                             !(alreadyConfiguredMpnId != previousMPNid && alreadyConfiguredMpnId.length != 0) &&
                              <Button
                                className="btn btn-lg btn-border-light px-4 pl-11 pr-11"
                                variant='light'
                                disabled
                              >
                                Verify
                              </Button>}
                            {
                            // isEditAllowed &&
                             !(alreadyConfiguredMpnId.length > 0) && !(alreadyConfiguredMpnId.length === 0) && <Button
                              className="btn btn-lg btn-border-light px-4 pl-11 pr-11"
                              variant='light'
                              disabled
                            >
                              Verify
                            </Button>}

                          </Col>
                        </Row>

                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={3}>
                    {/* {
                      // isEditAllowed && 
                      (alreadyConfiguredMpnId != previousMPNid) &&
                      !confirmLoadingFlag &&
                        <label className="cpointer" onClick={() => {
                          // setIsEditAllowed(false);
                           setAlreadyConfiguredMpnId(previousMPNid);
                            setIsMpnVerified(null);
                        }}>
                          <span className="back-blue">&nbsp;</span>&nbsp;<strong className='back-blue-color'>Back</strong>
                        </label>
                      }
                      {
                      !isEditAllowed && 
                      !confirmLoadingFlag &&
                        <p className='empty-paragraph pb-3 mb-8'></p>
                      } */}
                     </Col>
                      
                   
                    <Col md={9} className="text-right">
                      <div className="button-wrapper mr-2">
                        {
                        // isEditAllowed &&
                         ((alreadyConfiguredMpnId === previousMPNid)
                          // || alreadyConfiguredMpnId.length === 0 
                        ) && !isVerificationHold && <Button
                          className="btn btn-lg mx-2"
                          variant="light"
                          disabled
                        >
                          Clear
                        </Button>}
                        {
                        // isEditAllowed &&
                         isVerificationHold && <Button
                          className="btn btn-lg mx-2"
                          variant="light"
                          disabled
                        >
                          Clear
                        </Button>}

                        {
                        // isEditAllowed &&
                        //  alreadyConfiguredMpnId
                        (alreadyConfiguredMpnId != previousMPNid)
                          // && alreadyConfiguredMpnId.length > 0 
                          && !confirmLoadingFlag &&
                          <Button
                            className="btn btn-lg btn-border-light mx-2"
                            variant="light"
                            onClick={() => { 
                              setIsMpnVerified(false);
                              setMpnVerifyMessage("");
                              setPlaVerifyMessage("");
                              setMpnHelpMessage("");
                              setPlaHelpMessage("");
                              setPartnerName("");
                              setMpnMessage("");setMpnInfoMessage("");
                              GetMPNData();
                              // setAlreadyConfiguredMpnId(previousMPNid); 
                              // setVerifyMessage(""); setIsMpnVerified(null);
                             }}
                          >
                            Clear
                          </Button>}
                        {
                          // isEditAllowed &&
                          //  !isValidMpaStatus && !isValidPlaId &&
                            !isMpnVerified &&
                          <>
                            <Button
                              className="btn btn-lg ml-2 px-4"
                              variant="light"
                              disabled
                            >
                              Save
                            </Button>
                          </>
                        }
                        {
                          // isEditAllowed && 
                          // isValidMpaStatus && isValidPlaId &&
                           isMpnVerified && !confirmLoadingFlag &&
                          <Button
                            className="btn btn-lg ml-2 px-4"
                            onClick={() => {
                              MPNidUpdate(alreadyConfiguredMpnId);
                            }}
                          >
                            Save
                          </Button>
                        }

                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </>}
      </div >
    </>
  )
}

export default ProfileMicrosoftResellerPrerequisite